import { ResourcePoolImpl } from './ResourcePoolImpl';
import { JSONResource } from './JSONResource';

export class JSONResourcePool extends ResourcePoolImpl<JSONResource, Record<string, any>> {
  createResource(resourceId: string): JSONResource {
    return new JSONResource(resourceId);
  }

  loadData(data: string): Map<string, any> {
    return JSON.parse(data);
  }
}
